import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import Button from "@/components/Button";

export default function WizardNavigation({
  onBack,
  onNext,
  disableNext = false,
  hideBack = false,
  nextLabel = "Weiter",
}) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] sm:relative sm:shadow-none sm:pt-4 sm:p-0 flex gap-3 z-10">
      {!hideBack && (
        <Button
          variant="secondary"
          onClick={onBack}
          iconLeft={<ArrowLeftIcon className="h-4 w-4" />}
        >
          Zurück
        </Button>
      )}
      <Button
        variant="primary"
        onClick={onNext}
        disabled={disableNext}
        iconRight={<ArrowRightIcon className="h-4 w-4" />}
        className={`ml-auto ${
          disableNext ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {nextLabel}
      </Button>
    </div>
  );
}
